import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import AirlineSeatLegroomNormalIcon from '@material-ui/icons/AirlineSeatLegroomNormal';
import { fetchDefault } from '../Utils.js';


const useStyles = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 180,
    },
    menu: {
        width: 180,
    },
}));

export default function SeatSelect(props) {
    const classes = useStyles();

    const [isSelected, setIsSelected] = React.useState(false);
    const handleChange = event => {
        if (!isSelected) {
            props.onTableChanged(event.target.value);

            setTimeout(function () { setIsSelected(false); }, 1000);
        }
        setIsSelected(true);
    };

    return (
        <TextField
            id="outlined-select-currency"
            select
            label="Select"
            className={classes.textField}
            value={props.seat}
            onChange={handleChange}
            SelectProps={{
                MenuProps: {
                    className: classes.menu,
                },
            }}
            margin="normal"
            variant="outlined"
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <AirlineSeatLegroomNormalIcon />
                    </InputAdornment>
                ),
            }}
        >
            {props.tableList.map(option => (
                <MenuItem key={option.id} value={option.id}>
                    {option.tableName}
                </MenuItem>
            ))}
        </TextField>
    );

}



// WEBPACK FOOTER //
// ./src/components/seat/SeatSelect.js